import React from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useAppContext } from '../AppContext';

function NexusCard({ nexus, userNexusId }) {
    const { t } = useTranslation();
    const { handlePageChange } = useAppContext();
    return (
        <div
            className="group relative flex flex-col h-72 rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 hover:scale-[1.03] hover:-translate-y-2 ring-1 ring-white/10 hover:ring-cyan-500/50 shadow-2xl bg-black"
            onClick={() => handlePageChange('nexus', { nexusId: nexus.id })}
        >
            <div className="absolute inset-0 z-0 bg-cover bg-center transition-transform duration-1000 group-hover:scale-110 opacity-50 group-hover:opacity-70 mix-blend-screen"
                 style={{ backgroundImage: `url(${nexus.coverImageURL})` }}>
            </div>
            
            <div className="absolute inset-0 z-10 bg-gradient-to-t from-black via-black/80 to-transparent"></div>

            <div className="absolute top-4 left-4 z-20">
                <div className="w-12 h-12 rounded-full ring-2 ring-white/20 flex items-center justify-center bg-black/60 backdrop-blur-md" style={{ borderColor: nexus.nexusColor || '#3730a3' }}>
                    <LucideIcons.Shield className="text-white opacity-80" size={24} style={{ color: nexus.nexusColor || '#fff' }} />
                </div>
            </div>

            <div className="relative z-20 mt-auto p-6 flex flex-col">
                <div className="flex justify-between items-end mb-2">
                    <h4 className="font-extrabold text-2xl text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400 uppercase tracking-wider truncate drop-shadow-md">
                        {nexus.name}
                    </h4>
                    <span className="text-xs font-bold px-2 py-1 bg-cyan-900/50 text-cyan-300 rounded-md border border-cyan-500/30 whitespace-nowrap">
                        LVL {nexus.level || 1}
                    </span>
                </div>
                
                <p className="text-sm text-gray-300 line-clamp-2 mb-4 h-10 italic">
                    "{nexus.description}"
                </p>
                
                <div className="flex items-center justify-between mt-auto border-t border-white/10 pt-4">
                    <div className="flex items-center gap-1 text-sm font-semibold text-gray-300">
                        <LucideIcons.Users size={16} className="text-cyan-400" /> 
                        <span>{nexus.memberCount} {t('nexusCard.members')}</span>
                    </div>
                    
                    {userNexusId && userNexusId !== nexus.id ? (
                        <div className="text-xs font-bold text-red-400/80 uppercase tracking-widest flex items-center gap-1">
                            <LucideIcons.Lock size={12} /> Locked
                        </div>
                    ) : userNexusId === nexus.id ? (
                        <div className="text-xs font-bold text-green-400 uppercase tracking-widest flex items-center gap-1">
                            <LucideIcons.Check size={12} /> Joined
                        </div>
                    ) : (
                        <div className="text-xs font-bold text-cyan-400 uppercase tracking-widest group-hover:text-white transition-colors flex items-center gap-1">
                            Enter <LucideIcons.ChevronRight size={14} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default NexusCard;